import { MouseEvent, useState } from "react";
import { Container, Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "./Header.scss";
import { useAppContext } from "./context";
import { useAuth } from "../../auth";
import { helpCentreLink } from "../HelpCentre/content";
import { useFormProgress } from "./form-progress-context";
import LeaveFormWarning from "./LeaveFormWarning";

const HeaderComponent = () => {
  const {appName, appNameLoaded, helpCentreEnabled} = useAppContext();
  const { isLoggedIn } = useAuth();
  const { formInProgress } = useFormProgress();
  const navigate = useNavigate();
  // Where the patient asked to go, held back until they confirm leaving the form.
  const [pendingDestination, setPendingDestination] = useState<string | null>(null);
  // ADHD and AEDS share a deployment, so the section comes from the patient's service.
  const helpLink = helpCentreLink(appName[1]);

  // Every header link goes through this: mid-form it asks first, otherwise it behaves as a normal link.
  const confirmBeforeLeaving = (destination: string) => (e: MouseEvent) => {
    if (!formInProgress) return;

    e.preventDefault();
    setPendingDestination(destination);
  };

  return (
    <header
      className="nhsuk-header"
      role="banner"
      style={{
        background: "#005EB8",
        width: "auto",
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-start",
        borderBottom: "1px solid rgba(255,255,255,.2)",
        height: "52px",
      }}
    >
      <Container style={{ justifyContent: "center", maxWidth: "1024px"}}>
        <Grid container alignContent={"center"} justifyContent={"space-between"} alignItems={"center"}>
          <Grid item>
            <div
              className="nhsuk-header__content"
              id="content-header"
              style={{ alignItems: "center", color: "white", fontSize: "1rem" }}
            >
              {appNameLoaded && (
                // The service name doubles as the route back to the dashboard, on every page.
                <Link
                  className={"nhsuk-header__navigation-link rs-header__service-name"}
                  to={"/"}
                  onClick={confirmBeforeLeaving("/")}
                >
                  {document.body.offsetWidth <= 900 && <>{appName[1]}</>}
                  {document.body.offsetWidth > 900 && (
                    <>{appName[0]}</>
                  )}
                </Link>
              )}
            </div>
          </Grid>
          <Grid item style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Link
              className={"nhsuk-header__navigation-link"}
              to={"/"}
              onClick={confirmBeforeLeaving("/")}
            >
              Home
            </Link>
            {helpCentreEnabled && (
              <Link
                className={"nhsuk-header__navigation-link"}
                to={helpLink}
                onClick={confirmBeforeLeaving(helpLink)}
              >
                Help
              </Link>
            )}
            {isLoggedIn && window.location.href.indexOf('login') == -1 && (
              <a className={"nhsuk-header__navigation-link"} href={process.env.REACT_APP_API_URL + "logout"}>Logout</a>
            )}
          </Grid>
        </Grid>
      </Container>

      {pendingDestination && (
        <LeaveFormWarning
          onStay={() => setPendingDestination(null)}
          onLeave={() => {
            const destination = pendingDestination;
            setPendingDestination(null);
            navigate(destination);
          }}
        />
      )}
    </header>
  );
};

export default HeaderComponent;
